import { ApplicationController } from "../../support/application-controller";

export default class extends ApplicationController {
    doDeleteOrganization(e) {
        const url = e.target.dataset.deleteOrganizationUrl;

        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4) return;
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.response);
                window.location.href = response.redirectTo;
            } else {
                console.warn(xhr.status, xhr.response);
                let msg = "Failed to delete organization.";
                try {
                    const body = JSON.parse(xhr.response);
                    if (body.error) msg = body.error;
                } catch (_) { /* ignore */ }
                alert(msg);
            }
        };
        xhr.open("DELETE", url);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("X-CSRF-Token", this._csrfToken());
        xhr.send(JSON.stringify({}));
    }

    _csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.content : '';
    }
}
